import api, { buildURLWithParams } from '@/services/api';

import {
  type RoadmapCustomerCareReport,
  type RoadmapTempoReportByItem,
  type RoadmapTempoReportByUser,
  type RoadmapTempoReportRequest,
} from '../types';

const BASE_URL = 'roadmaps';

export const getRoadmapTempoReportByUser = async (request: RoadmapTempoReportRequest) => {
  return await api.post<RoadmapTempoReportByUser[]>(`${BASE_URL}/report/tempo`, request);
};

export const getRoadmapTempoReportByItem = async (request: RoadmapTempoReportRequest, idUser?: number) => {
  return await api.post<RoadmapTempoReportByItem[]>(
    buildURLWithParams(`${BASE_URL}/report/tempo-item`, { idUser }),
    request,
  );
};

export const getRoadmapTempoWithHoursAllocation = async () => {
  return await api.get<RoadmapTempoReportByItem[]>(`${BASE_URL}/report/item`);
};

export const getRoadmapCustomerCarePendingInstall = async () => {
  return await api.get<RoadmapCustomerCareReport[]>(`${BASE_URL}/report/customer-care`);
};
